var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-icon 1",
    clipPath: "url(#clip0_7505_366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M28 0C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0H28ZM28 2H4C2.94564 2 2.08183 2.81588 2.00549 3.85074L2 4V28C2 29.0544 2.81588 29.9182 3.85074 29.9945L4 30H28C29.0544 30 29.9182 29.1841 29.9945 28.1493L30 28V4C30 2.94564 29.1841 2.08183 28.1493 2.00549L28 2ZM8 5.69127C8.1685 5.69127 8.33427 5.73385 8.48192 5.81506L25.4069 15.1238C25.8908 15.3899 26.0673 15.998 25.8012 16.4819C25.7098 16.6481 25.573 16.7848 25.4069 16.8762L8.48192 26.1849C7.998 26.4511 7.38994 26.2746 7.12378 25.7906C7.04258 25.643 7 25.4772 7 25.3087V6.69127C7 6.13899 7.44772 5.69127 8 5.69127ZM9 8.382V23.617L22.849 15.999L9 8.382Z",
    fill: "#1B1C1F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7505_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.025f72b90f62363ae816fb604196ee7d.svg";
export { ForwardRef as ReactComponent };